export const initialState = {
  menuBarToggle: false,
  viewIndex: 1,
  category: "adalya",
  activeFlavor: {
    title: "Love 66  (Adalya)",
    description:
      'Embark on a journey through flavor\'s mysterious depths with "Love 66." This captivating blend marries the exotic allure of passion fruit, honeydew melon, and watermelon, gently kissed by a whisper of mint. Each puff reveals layers of elegance and intrigue, inviting you to lose yourself in its enigmatic charm.',
    price: "35",
    title_fr: "Love 66  (Adalya)",
    description_fr:
      "Embarquez dans un voyage à travers les profondeurs mystérieuses des saveurs avec \"Love 66\" d'Adalya. Ce mélange captivant unit l'attrait exotique du fruit de la passion, du melon miel et de la pastèque, délicatement embrassé par un murmure de menthe. Chaque bouffée révèle des couches d'élégance et d'intrigue, vous invitant à vous perdre dans son charme énigmatique.",
    category: "adalya",
    flavor: 1,
  },
  contactInfo: {
    _id: "",
    name: "",
    email: "",
    message: "",
    first: false,
    second: false,
  },
  contacts: [],
  navbarVisible: true,
  shishaData: [],
};
export const reducer = (state, { type, payload }) => {
  switch (type) {
    case "menu-toggle":
      return { ...state, menuBarToggle: payload };
    case "view-index":
      return { ...state, viewIndex: payload };
    case "category":
      return { ...state, category: payload };
    case "active-flavor":
      return {
        ...state,
        activeFlavor: payload,
      };
    case "input":
      return {
        ...state,
        contactInfo: { ...state.contactInfo, [payload.name]: payload.value },
      };
    case "contact-info":
      return { ...state, contacts: [payload, ...state.contacts] };
    case "navbar-scroll":
      return { ...state, navbarVisible: payload };
    case "reset":
      // Handle resetting the contactInfo to its initial state
      return {
        ...state,
        contactInfo: initialState.contactInfo,
      };
    case "SET_SHISHA_DATA":
      return { ...state, shishaData: payload };
    default:
      return state;
  }
};
